import React from 'react';
import { Box, Text } from '@wix/design-system';
import { Countdown } from '../Countdown';
import dayjs from 'dayjs';
import s from './SaleBanner.scss';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
export const LastDaySaleBannerContent = ({ saleText, saleEndDate }) => {
    const currentDateUtc = dayjs().utc().valueOf();
    const endDate = dayjs(saleEndDate).utc().valueOf();
    return (React.createElement(Box, { dataHook: "last-day-sale-banner-content", align: "center", verticalAlign: "bottom" },
        React.createElement(Text, { dataHook: "last-day-sale-text", weight: "bold", size: "small" }, saleText),
        saleEndDate && (React.createElement(Box, { marginLeft: "SP1", marginBottom: "2px" },
            React.createElement(Countdown, { currentDate: currentDateUtc, endDate: endDate, classNames: {
                    wrapper: s.countdown,
                    timePart: s.countdownTimePart,
                    label: s.countdownTimePartLabel,
                    separator: s.countdownSeparator,
                    timePartWrapper: s.countdownTimePartWrapper,
                } })))));
};
//# sourceMappingURL=LastDaySaleBannerContent.js.map